exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-2d8cc30d] {\n  font-size: 16px;\n}\n.container .row[data-v-2d8cc30d] {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 10px 0;\n}\n.container .row .key[data-v-2d8cc30d] {\n  display: inline-block;\n  width: 80px;\n  margin-right: 15px;\n  text-align: right;\n  color: #333333;\n  font-weight: bold;\n}\n", ""]);

// exports
